import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-clamped-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
var q = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"],
  x = function x(t) {
    var e = 0;
    for (var r = 0; r < t.length; r++) {
      var n = t[r],
        l = q.indexOf(n);
      e = e * 83 + l;
    }
    return e;
  },
  p = function p(t, e) {
    var r = "";
    for (var n = 1; n <= e; n++) {
      var l = Math.floor(t) / Math.pow(83, e - n) % 83;
      r += q[Math.floor(l)];
    }
    return r;
  };
var f = function f(t) {
    var e = t / 255;
    return e <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
  },
  h = function h(t) {
    var e = Math.max(0, Math.min(1, t));
    return e <= .0031308 ? Math.trunc(e * 12.92 * 255 + .5) : Math.trunc((1.055 * Math.pow(e, .4166666666666667) - .055) * 255 + .5);
  },
  F = function F(t) {
    return t < 0 ? -1 : 1;
  },
  M = function M(t, e) {
    return F(t) * Math.pow(Math.abs(t), e);
  };
var d = /*#__PURE__*/function (_Error) {
  _inherits(d, _Error);
  var _super = _createSuper(d);
  function d(e) {
    var _this;
    _classCallCheck(this, d);
    _this = _super.call(this, e), _this.name = "ValidationError", _this.message = e;
    return _this;
  }
  return _createClass(d);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var C = function C(t) {
    if (!t || t.length < 6) throw new d("The blurhash string must be at least 6 characters");
    var e = x(t[0]),
      r = Math.floor(e / 9) + 1,
      n = e % 9 + 1;
    if (t.length !== 4 + 2 * n * r) throw new d("blurhash length mismatch: length is ".concat(t.length, " but it should be ").concat(4 + 2 * n * r));
  },
  N = function N(t) {
    try {
      C(t);
    } catch (e) {
      return {
        result: !1,
        errorReason: e.message
      };
    }
    return {
      result: !0
    };
  },
  z = function z(t) {
    var e = t >> 16,
      r = t >> 8 & 255,
      n = t & 255;
    return [f(e), f(r), f(n)];
  },
  L = function L(t, e) {
    var r = Math.floor(t / 361),
      n = Math.floor(t / 19) % 19,
      l = t % 19;
    return [M((r - 9) / 9, 2) * e, M((n - 9) / 9, 2) * e, M((l - 9) / 9, 2) * e];
  },
  U = function U(t, e, r, n) {
    C(t), n = n | 1;
    var l = x(t[0]),
      m = Math.floor(l / 9) + 1,
      b = l % 9 + 1,
      i = (x(t[1]) + 1) / 166,
      u = new Array(b * m);
    for (var o = 0; o < u.length; o++) if (o === 0) {
      var a = x(t.substring(2, 6));
      u[o] = z(a);
    } else {
      var _a = x(t.substring(4 + o * 2, 6 + o * 2));
      u[o] = L(_a, i * n);
    }
    var c = e * 4,
      s = new Uint8ClampedArray(c * r);
    for (var _o = 0; _o < r; _o++) for (var _a2 = 0; _a2 < e; _a2++) {
      var y = 0,
        B = 0,
        R = 0;
      for (var w = 0; w < m; w++) for (var P = 0; P < b; P++) {
        var G = Math.cos(Math.PI * _a2 * P / e) * Math.cos(Math.PI * _o * w / r),
          T = u[P + w * b];
        y += T[0] * G, B += T[1] * G, R += T[2] * G;
      }
      var V = h(y),
        I = h(B),
        E = h(R);
      s[4 * _a2 + 0 + _o * c] = V, s[4 * _a2 + 1 + _o * c] = I, s[4 * _a2 + 2 + _o * c] = E, s[4 * _a2 + 3 + _o * c] = 255;
    }
    return s;
  },
  j = U;
var A = 4,
  D = function D(t, e, r, n) {
    var l = 0,
      m = 0,
      b = 0,
      g = e * A;
    for (var u = 0; u < e; u++) {
      var c = A * u;
      for (var s = 0; s < r; s++) {
        var o = c + s * g,
          a = n(u, s);
        l += a * f(t[o]), m += a * f(t[o + 1]), b += a * f(t[o + 2]);
      }
    }
    var i = 1 / (e * r);
    return [l * i, m * i, b * i];
  },
  $ = function $(t) {
    var e = h(t[0]),
      r = h(t[1]),
      n = h(t[2]);
    return (e << 16) + (r << 8) + n;
  },
  H = function H(t, e) {
    var r = Math.floor(Math.max(0, Math.min(18, Math.floor(M(t[0] / e, .5) * 9 + 9.5)))),
      n = Math.floor(Math.max(0, Math.min(18, Math.floor(M(t[1] / e, .5) * 9 + 9.5)))),
      l = Math.floor(Math.max(0, Math.min(18, Math.floor(M(t[2] / e, .5) * 9 + 9.5))));
    return r * 19 * 19 + n * 19 + l;
  },
  O = function O(t, e, r, n, l) {
    if (n < 1 || n > 9 || l < 1 || l > 9) throw new d("BlurHash must have between 1 and 9 components");
    if (e * r * 4 !== t.length) throw new d("Width and height must match the pixels array");
    var m = [];
    var _loop = function _loop(s) {
      var _loop2 = function _loop2(_o2) {
        var a = _o2 == 0 && s == 0 ? 1 : 2,
          y = D(t, e, r, function (B, R) {
            return a * Math.cos(Math.PI * _o2 * B / e) * Math.cos(Math.PI * s * R / r);
          });
        m.push(y);
      };
      for (var _o2 = 0; _o2 < n; _o2++) {
        _loop2(_o2);
      }
    };
    for (var s = 0; s < l; s++) {
      _loop(s);
    }
    var b = m[0],
      g = m.slice(1),
      i = "",
      u = n - 1 + (l - 1) * 9;
    i += p(u, 1);
    var c;
    if (g.length > 0) {
      var _s = Math.max.apply(Math, _toConsumableArray(g.map(function (a) {
          return Math.max.apply(Math, _toConsumableArray(a));
        }))),
        o = Math.floor(Math.max(0, Math.min(82, Math.floor(_s * 166 - .5))));
      c = (o + 1) / 166, i += p(o, 1);
    } else c = 1, i += p(0, 1);
    return i += p($(b), 4), g.forEach(function (s) {
      i += p(H(s, c), 2);
    }), i;
  },
  S = O;
export { d as ValidationError, j as decode, S as encode, N as isBlurhashValid };